import { Component, Host, Prop, h } from '@stencil/core';

/**
 * @slot - Designed to receive cell's content.
 */
@Component({
  tag: 'sy-cell',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class Cell {
  /**
   * Defines the position of the first row of the cell.
   */
  @Prop({ reflect: true }) rowStart: number;

  /**
   * Defines the position of the first column of the cell.
   */
  @Prop({ reflect: true }) colStart: number;

  /**
   * Defines the height in rows of the cell.
   */
  @Prop() height: number;

  /**
   * Defines the width in columns of the cell.
   */
  @Prop() width: number;

  private getCellStyle(): any {
    const style: any = {};

    if (this.rowStart) {
      style.gridRowStart = this.rowStart;
    }
    if (this.colStart) {
      style.gridColumnStart = this.colStart;
    }
    if (this.height) {
      style.gridRowEnd = `span ${this.height}`;
    }
    if (this.width) {
      style.gridColumnEnd = `span ${this.width}`;
    }

    return style;
  }

  render() {
    return (
      <Host style={this.getCellStyle()}>
        <slot></slot>
      </Host>
    );
  }
}
